export const initialFormValues = {
  nickname: '',
  image:'',
  species:'',
  description:'',
  datePlanted:'',
  frequency:'daily',
  careInstructions:'',
  // user: '',
}

export const initialDayValues = {
  monday: false,
  tuesday: false,
  wednesday: false,
  thursday: false,
  friday: false,
  saturday: false,
  sunday: false,
}

export const initialFormErrors = {
  nickname: '',
  species:'',
  frequency:'',
}

